import { useEffect, useState } from "react";
import {Link, NavLink, useNavigate, useParams} from "react-router-dom";
import api from "../api/api";
import Header from "./Components/Header";
import '../styles/Products.css';
import {IMAGE_URL} from "../path";
import FooterWithSignup from "./Components/FooterWithSignup";
import cartonBackground from "../assets/images/carton-background.jpg";

function Products() {
    const { slug } = useParams();
    const [page, setPage] = useState<any>(null);
    const navigate = useNavigate();

    async function fetchHomeData() {
        try {
            const response = slug
                ? await api.get(`/fetch-products/${slug}`)
                : await api.get("/fetch-products");

            setPage(response.data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        fetchHomeData();
    }, [slug]);

    const heroItems = (page?.ranges ?? []).map((range: any) => ({
        ...range,
        display_name:
            range.slug === null
                ? "Our Range"
                : range.display_name,
        short_description:
            range.slug === null
                ? page?.header_body
                : range.header_body,
        cover_image:
            range.slug === null
                ? page?.cover_image
                : range.header_image,
    }));

    const currentIndex = heroItems.findIndex(
        (item: any) => (item.slug ?? null) === (slug ?? null)
    );

    const previousRange = () => {
        const previousIndex =
            currentIndex === 0
                ? heroItems.length - 1
                : currentIndex - 1;

        const previous = heroItems[previousIndex];

        navigate(
            previous.slug
                ? `/products/${previous.slug}`
                : "/products"
        );
    };


    const [itemsPerRow, setItemsPerRow] = useState(4);
    const [shelfImage, setShelfImage] = useState("/wooden-platform@2x.png");

    useEffect(() => {
        const updateLayout = () => {
            if (window.innerWidth <= 768) {
                setItemsPerRow(1);
                setShelfImage("/wooden-platform-03.png");
            } else if (window.innerWidth <= 1024) {
                setItemsPerRow(2);
                setShelfImage("/wooden-platform-02.png");
            } else {
                setItemsPerRow(4);
                setShelfImage("/wooden-platform@2x.png");
            }
        };

        updateLayout();

        window.addEventListener("resize", updateLayout);

        return () => {
            window.removeEventListener("resize", updateLayout);
        };
    }, []);

    const nextRange = () => {
        const nextIndex =
            currentIndex === heroItems.length - 1
                ? 0
                : currentIndex + 1;

        const next = heroItems[nextIndex];

        navigate(
            next.slug
                ? `/products/${next.slug}`
                : "/products"
        );
    };

    const currentHero = heroItems[currentIndex];
    console.log(currentHero)

    return (
        <div className="products-page">
            <div
                className="products-hero-section"
                style={{
                    backgroundImage: `url(${
                        currentHero?.cover_image
                            ? `${IMAGE_URL}/${currentHero.cover_image}`
                            : cartonBackground
                    })`,
                }}
            >
                <Header />

                <div className="products-hero-inner">
                    <h1>{currentHero?.display_name}</h1>
                    <p>{currentHero?.short_description}</p>



                </div>
                <div className="products-hero-bottom">
                    <div className="products-hero-button">
                        <div className="products-hero-button-inner" onClick={() => {navigate('/lets-cook/by-cuisine')}}>
                            Start Cooking
                        </div>
                    </div>
                    <div className="products-hero-gallery-navigation">
                        <div
                            onClick={previousRange}
                            className="gallery-nav-arrow"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                <g id="Group_918" data-name="Group 918" transform="translate(-792 -942)">
                                    <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" transform="translate(792 942)" fill="#436ab3"/>
                                    <path id="Path_14050" data-name="Path 14050" d="M13.25,4.5l-5,5,5,5" transform="translate(792.75 945)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                </g>
                            </svg>

                        </div>

                        <div className="product-hero-dots">
                            {heroItems.map((item: any) => (
                                <div
                                    key={item.id}
                                    className={`navigation-dot ${
                                        item.slug === slug ||
                                        (!slug && item.slug === null)
                                            ? "active"
                                            : ""
                                    }`}
                                    onClick={() =>
                                        navigate(
                                            item.slug
                                                ? `/products/${item.slug}`
                                                : "/products"
                                        )
                                    }
                                />
                            ))}
                        </div>


                        <div
                            onClick={nextRange}
                            className="gallery-nav-arrow"
                        >
                            <svg id="Group_917" data-name="Group 917" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" fill="#436ab3"/>
                                <path id="Path_14050" data-name="Path 14050" d="M8.25,4.5l5,5-5,5" transform="translate(2.75 3)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                            </svg>

                        </div>
                    </div>
                </div>
            </div>
            <div className="products-main-page">
                <div className="ranges-buttons">
                    {page?.ranges?.map((item: any) => {

                        return (
                            <NavLink
                                key={item.id}
                                end={!item.slug}
                                to={item.slug ? `/products/${item.slug}` : "/products"}
                                className={({ isActive }) =>
                                    `range-button${isActive ? " active" : ""}`
                                }
                            >
                                {item.display_name}
                            </NavLink>
                        );
                    })}
                </div>
                <div className="products-page-list">
                    {page?.products &&
                        Array.from(
                            {
                                length: Math.ceil(
                                    page.products.length / itemsPerRow
                                ),
                            },
                            (_, rowIndex) => (
                                <div className="products-page-row" key={rowIndex}>
                                    <div className="products-page-items">
                                        {page.products
                                            .slice(
                                                rowIndex * itemsPerRow,
                                                rowIndex * itemsPerRow + itemsPerRow
                                            )
                                            .map((product: any) => (
                                                <div
                                                    className="products-page-item"
                                                    key={product.id}
                                                >
                                                    <div className="products-page-link" />

                                                    <div className="products-page-image">
                                                        <img
                                                            src={`${IMAGE_URL}${product.product_image}`}
                                                            alt={product.product_name}
                                                        />
                                                    </div>

                                                    <Link
                                                        to={`/product/${product.slug}`}
                                                        className="products-page-shop"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M10 4V16M4 10H16"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                            />
                                                        </svg>
                                                    </Link>
                                                </div>
                                            ))}
                                    </div>

                                    <div className="products-page-shelf">
                                        <img
                                            src={shelfImage}
                                            alt="Shelf"
                                        />
                                    </div>
                                </div>
                            )
                        )}
                </div>
            </div>
            <FooterWithSignup />
        </div>
    );
}

export default Products;
